import { useContext } from "react";
import { ThemeContext } from "../../../Context/ThemeContext";
import { genericErrorMessage } from "../../../domain/constants/error";
import styles from "./Error.module.scss";

const Error = ({ errorMessage, setStartLocation, setTimeNow }) => {
  const themeContext = useContext(ThemeContext);

  const errorLinks = [
    { text: "Current Location", onClick: setStartLocation },
    { text: "the present", onClick: setTimeNow },
    { text: "current", onClick: setTimeNow },
    { text: "now", onClick: setTimeNow },
  ];

  const renderErrorMessage = (errorLinks) => {
    if (errorMessage) {
      for (const { text, onClick } of errorLinks) {
        if (errorMessage.includes(text)) {
          const parts = errorMessage.split(text);
          return (
            <>
              {parts[0]}
              <span
                onClick={onClick}
                className={styles["error-link"]}
                style={{ color: themeContext.theme.primaryColour }}
              >
                {text}
              </span>
              {parts[1]}
            </>
          );
        }
      }
    }

    return errorMessage || genericErrorMessage;
  };

  return (
    <div className={styles["error"]}>
      <span>{renderErrorMessage(errorLinks)}</span>
    </div>
  );
};

export default Error;
